package ru.it_mozaika.sender.js.application.frames.segments.static

import io.ktor.client.call.*
import js.core.ReadonlyRecord
import js.core.jso
import mui.system.responsive
import mui.system.sx
import ru.it_mozaika.sender.common.models.NamedItem
import ru.it_mozaika.sender.common.models.ColumnsFilter
import tanstack.react.table.useReactTable
import tanstack.table.core.*
import web.window.WindowTarget
import mui.icons.material.CloudDownloadSharp
import mui.icons.material.CloudUploadSharp
import mui.icons.material.DeleteForeverSharp
import mui.material.*
import mui.material.styles.Theme
import mui.material.styles.useTheme
import oldcomponents.NotyType
import oldcomponents.showNotification
import react.*
import ru.it_mozaika.components.*
import ru.it_mozaika.sender.js.application.Http
import ru.it_mozaika.utils.checkResponseError
import ru.it_mozaika.sender.js.application.components.segments.deleteFromStaticSegmentDialog
import ru.it_mozaika.sender.js.application.components.segments.staticSegmentDialog
import ru.it_mozaika.sender.js.application.components.segments.uploadEmailsDialog
import ru.it_mozaika.components.commonTableSkeletonFrame
import ru.it_mozaika.sender.js.application.frames.MainCard
import web.cssom.*

val staticSegmentsListFrame = VFC {
    val (segments, setSegments) = useState<List<NamedItem>>(listOf())
    val (size, setSize) = useState(0)
    val (selectedProperty, setSelectedProperty) = useState("")
    val (rowsPerPage, setRowsPerPage) = useState(10)
    val (page, setPage) = useState(0)
    val (checkedProperties, setCheckedProperties) = useState(listOf<String>())
    val (showFilter, setShowFilter) = useState(false)
    var (columnVisibility, setColumnVisibility) = useState<ReadonlyRecord<String, Boolean>>(jso {})
    val (columnOrder, setColumnOrder) = useState<ColumnOrderState>(jso {})
    val (propertiesDict, setPropertiesDict) = useState<ColumnsFilter>()
    val (searchQuery, setSearchQuery) = useState("")
    val (propertiesFilter, setPropertiesFilter) = useState<List<ColumnsFilter>>(listOf())
    val tableColumns = listOf("ID", "Наименование", "Действия")
    val (selectedSegment, setSelectedSegment) = useState<List<String>>(listOf())
    val (uploadKey, setUploadKey) = useState<String>()
    val (showDeleteDialog, setShowDeleteDialog) = useState(false)
    val (showUploadDialog, setShowUploadDialog) = useState(false)
    val (selectedStaticSegmentId, setSelectedStaticSegmentId) = useState<String>()
    val (showStaticSegmentDialog, setShowStaticSegmentDialog) = useState(false)
    fun getData() {
        Http.get("/segments/static/size") { response ->
            response.checkResponseError()?.let {
                showNotification(it, NotyType.Error)
                return@get
            }
            setSize(response.body<Int>())
        }
        Http.get(
            "/segments/static",
            mapOf(
                "page" to (page + 1).toString(),
                "rows" to rowsPerPage.toString()
            )
        ) { response ->
            response.checkResponseError()?.let {
                showNotification(it, NotyType.Error)
                return@get
            }
            setSegments(response.body<List<NamedItem>>())
        }
    }
    useEffect(rowsPerPage, page, searchQuery) {
        getData()
    }
    val table = useReactTable<NamedItem>(
        options = jso {
            columns = useMemo(tableColumns) {
                tableColumns.map { column ->
                    jso<ColumnDef<NamedItem, Any?>> {
                        accessorFn = { item, _ ->
                            when (column) {
                                "ID" -> item.id
                                "Наименование" -> item.name
                                else -> ""
                            }
                        }
                        cell = ColumnDefTemplate { context ->
                            val value = context.getValue().toString()
                            val segmentId = context.row.getValue("ID").toString()
                            val columnId = context.column.id
                            if (columnId != "Действия") {
                                Box.create {
                                    +value
                                }
                            } else {
                                Box.create() {
                                    Stack {
                                        direction = responsive(StackDirection.row)
                                        sx {
                                            padding = 10.px
                                        }
                                        AvatarButton {
                                            tooltipTitle = "Скачать"
                                            CloudDownloadSharp()
                                            asDynamic().component = "a"
                                            asDynamic().href = "/api/v1/segments/static/${segmentId}/download"
                                            asDynamic().target = WindowTarget._self
                                        }
                                        AvatarButton {
                                            tooltipTitle = "Загрузить"
                                            CloudUploadSharp()
                                            onClick = {
                                                setUploadKey(segmentId)
                                                setShowUploadDialog(true)
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        id = column
                        header = StringOrTemplateHeader(column)
                    }
                }
            }.toTypedArray()
            this.data = useMemo(segments) { segments.toTypedArray() }
            this.state = jso {
                this.columnVisibility = columnVisibility
                this.columnOrder = columnOrder
            }
            this.onColumnVisibilityChange = {
                columnVisibility = it.unsafeCast<ReadonlyRecord<String, Boolean>>()
                setColumnVisibility(it.unsafeCast<ReadonlyRecord<String, Boolean>>())
            }
            this.onColumnOrderChange = {
                setColumnOrder(it.unsafeCast<Array<String>>())
            }
            this.getCoreRowModel = getCoreRowModel()
            this.debugTable = true
            this.debugHeaders = true
            this.debugColumns = true
        }
    )
    uploadEmailsDialog {
        this.isOpen = showUploadDialog
        this.onClose = {
            setShowUploadDialog(false)
            setSelectedSegment(listOf())
            setUploadKey(null)
        }
        this.selected = uploadKey
    }
    deleteFromStaticSegmentDialog {
        isOpen = showDeleteDialog
        onClose = {
            setShowDeleteDialog(false)
            setSelectedSegment(listOf())
        }
        this.segments = segments
        this.selected = selectedSegment
    }
    staticSegmentDialog {
        isOpen = showStaticSegmentDialog
        this.id = selectedStaticSegmentId
        onClose = {
            setSelectedStaticSegmentId(null)
            setShowStaticSegmentDialog(false)
        }
    }
//    tableFilter {
//        this.showFilter = showFilter
//        this.propertiesDict = propertiesDict
//        this.selectedProperty = selectedProperty
//        this.onClose = {
//            setShowFilter(false)
//            setSelectedProperty("")
//        }
//        this.handleOnSetCheckedValues = { selectedProperty, list ->
//            setCheckedProperties(list)
//            setPropertiesFilter {
//                if (list.isNotEmpty()) {
//                    if (propertiesFilter.find { property ->
//                            property.columnName == selectedProperty
//                        } == null) {
//                        val newValue = it.plus(ColumnsFilter(selectedProperty, list))
//                        newValue
//                    } else {
//                        val newValue = it.map { item ->
//                            if (item.columnName == selectedProperty) ColumnsFilter(
//                                selectedProperty,
//                                list
//                            ) else item
//                        }
//                        newValue
//                    }
//                } else {
//                    listOf()
//                }
//            }
//        }
//        this.checkedProperties = checkedProperties
//    }
    MainCard {
        title = "Статические сегменты"
        actions = Stack.create {
            this.direction = responsive(StackDirection.row)
            this.divider = Divider.create {
                orientation = Orientation.vertical
            }
            asDynamic().spacing = 2
            sx {
                this.width = 100.pct
                border = 2.px
                this.alignItems = AlignItems.center
                this.justifyContent = JustifyContent.flexStart
            }
            AvatarButton {
                onClick = {
                    setSelectedStaticSegmentId(null)
                    setShowStaticSegmentDialog(true)
                }
                tooltipTitle = "Добавить новый сегмент"
                mui.icons.material.AddCircleOutlineSharp()
            }
        }
        commonTableSkeletonFrame {
            currentSelected = selectedSegment
            toolbarActions = Stack.create {
                this.direction = responsive(StackDirection.row)
                this.divider = Divider.create {
                    orientation = Orientation.vertical
                }
                asDynamic().spacing = 2
                sx {
                    this.width = 100.pct
                    border = 2.px
                    this.alignItems = AlignItems.center
                    this.justifyContent = JustifyContent.flexStart
                }
                if (checkedProperties.isNotEmpty()) {
                    filterOffButton {
                        this.propertiesFilter = checkedProperties
                        this.handleOnFilterOffClick = {
                            setCheckedProperties(listOf())
                            setPropertiesFilter(listOf())
                            setSearchQuery("")
                        }
                    }
                }
                if (selectedSegment.isNotEmpty()) {
                    AvatarButton {
                        onClick = {
                            setShowDeleteDialog(true)
                        }
                        tooltipTitle = "Удалить сегменты"
                        palettecolor = useTheme<Theme>().palette.error
                        DeleteForeverSharp()
                    }
                }
            }
            this.label = "static-segments"
            this.propertiesFilter = propertiesFilter
            this.columnId = "ID"
            this.table = table
            this.onDoubleClickHandler = {
                setSelectedStaticSegmentId(it)
                setShowStaticSegmentDialog(true)
            }
            this.onPropertySelect = { property ->
                setSelectedProperty(property)
                if (showFilter) setShowFilter(false) else setShowFilter(true)
            }
            this.onSelectionChanged = { newSelected ->
                setSelectedSegment(newSelected)
            }
        }
        TablePagination {
            this.page = page
            this.count = size
            this.onPageChange = { _, newPage ->
                setPage(newPage.toInt())
            }
            this.onRowsPerPageChange = { event ->
                setRowsPerPage(event.target.asDynamic().value as Int)
                setPage(0)
            }
            this.rowsPerPage = rowsPerPage
        }
    }
}